import React, { useEffect, useState } from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select, TextField,Snackbar} from '@material-ui/core';
//import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Constants } from '../core/Constants';
import { FormDynamic } from '../core/resources/FormDynamic';

import { InfoSend } from './info-send/InfoSend';
import { LogoForm } from './logo-form/LogoForm';
import { Utils } from '../core/Utils';
import "./DynamicForm.scss"
import Countdown from 'react-countdown';


//import DateFnsUtils from '@date-io/date-fns';
//import itLocale from "date-fns/locale/it";

import ClipboardJS from 'clipboard';

const CryptoJS = require("crypto-js");

enum TYPEDATA {
  INPUT ="input",
  INPUTNUMBER = "inputnumber",
  CHECKBOX = "checkbox",
  LIST = "list",
  EMAIL= "email",
  DATE= "date",
  DATETIME= "datetime",
  TIME ="time"
}

/*const localeMap = {
  it: itLocale
};*/
interface PropsDynamicForm {
  form: FormDynamic;
  sendForm:()=>void;
  closeForm:()=>void;
}

export const DynamicForm: React.FC<PropsDynamicForm> = (props) => {
  
  const [formValidate, setFormValidate] = useState<boolean>(false);
  const [form, setForm] = useState<FormDynamic>(props.form);
  const [statusSend, setStatusSend] = useState<boolean>(false);
  const [errorEmail, setErrorEmail] = useState<boolean>(false);
  const [text, setText] = useState<string>("");

  useEffect(()=>{
    new ClipboardJS('.clipboard');

      addHeaderScript();
      

 
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  const addHeaderScript = ()=>{
    if(form.headerScript && form.headerScript.length > 0){
      try{
        const node = document.createRange().createContextualFragment(form.headerScript)
        document.getElementsByTagName('head')[0].appendChild(node);
      }catch(e){
        console.log("error added scripts",e);
      }
    }
  
 
  } 

  const handleSendData = () => {
    setStatusSend(false);
    let d: Array<{ id: string, v: string }> = []
    
      form.params.map((p) => 
        
        d.push({
          id: p.id,
          v: p.value
        })

      )
      d.push({
        id: "fullname",
        v: form.fullname
      })
      d.push({
        id: "surname",
        v: form.surname
      })
      let f = {
        code: form.idForm,
        p: d
      }

      let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(f), Constants.KEY).toString();
      let bytes = form.numberhash && CryptoJS.AES.decrypt(form.numberhash, Constants.KEY);
      let number = bytes && bytes.toString(CryptoJS.enc.Utf8);
      let split = ciphertext.split("+");
      let text = split.join(",")
      let username = form.username && form.username.replace("@","");
     
      let codeLink = Utils.isMobile() ? "api" : "web";
      
      if(Utils.isTelegram()){
        setText(text)
        setTimeout(()=>{
          const button:any = document.querySelector(".clipboard");
          button.click();
          window.open(`https://t.me/${username}`,'_blank');
          props.sendForm();
        },500)
       

      }else{
        window.open(`https://${codeLink}.whatsapp.com/send/?phone=${number}&text=${text}`,'_blank');
        props.sendForm();
      }
   
    

  }

  const handleConfirmSend = ()=>{
      setStatusSend(true);
  }   


  const changeValue = (idx: number, event: any) => {
    
      form.params[idx].value = event.target.value
      setForm(form);
      if(event.target.name === "email" ){
         if(!Utils.isEmail(event.target.value))
           setErrorEmail(true)
        else
          setErrorEmail(false)

         if(!form.params[idx].required &&  event.target.value.length === 0 )
          setErrorEmail(false)
       
        }
      isValidate()
      event.preventDefault();
  }

  const changeValueCkeckbox = (idx: number, event: any) => {

       form.params.filter(f => f.enable)[idx].value = event.target.checked ? "si" : "no"
      
      setForm(form);
      isValidate()
  }

  const changeFullname = (event: any) => {

      form.fullname = event.target.value;
      setForm(form);
      isValidate()
      event.preventDefault();

  }

  const changeSurname = (event: any) => {

    form.surname = event.target.value;
    setForm(form);
    isValidate()
    event.preventDefault();

}


  const changeReadPrivacy = (value: boolean) => {

      form.readprivacy = value;
      setForm(form);
      isValidate()

  }




  const isValidate = (): void => {
    
      let params = form.params.some(p => {
        return p.enable && p.required === true && (p.value === undefined || p.value === "" || p.value.length === 0)
      }
      )
      setFormValidate(!params && (form.fullname !== undefined && form.fullname !== "" && form.fullname.length !== 0) && ((form.privacy && form.readprivacy) || !form.privacy) && !errorEmail)
    

  }
  const rendererCountdown = (params:any) => {
    const { days,hours, minutes, seconds } = params;

    return (
          <div className="row countdown">
              <div className="col-3 d-flex align-items-center flex-column">
                  <span className="num">{days}</span>
                  <span className="lb">GG</span>
              </div>
              <div className="col-3 d-flex align-items-center flex-column">
                  <span className="num">{hours}</span>
                  <span className="lb">HH</span>
              </div>
              <div className="col-3 d-flex align-items-center flex-column">
              <span className="num">{minutes}</span>
                  <span className="lb">mm</span>
              </div>
              
              <div className="col-3 d-flex align-items-center flex-column">
                 <span className="num">{seconds}</span>
                  <span className="lb">ss</span>
              </div>
          </div>);
  };
  

    return <div id="form-container" className="container form-container">
      
      <div className="row" >
        <LogoForm  logobase64={form.image}  />
        <div className="mt-3 col-md-12 text-center">
          <h4 className="title-form">{form.title}</h4>
          {Utils.isTelegram() && <button className="clipboard"
          data-clipboard-text={text}>
          Copy this 
        </button>}
        </div>
      </div>
      <div className="row"> 
      {form.subtitle ?  <div className="mt-3 col-md-12"><p className="w-100 text-center">{form.subtitle}</p></div>:null }  
      
      {form.countdown ? 
        <div className="col-md-12 d-flex justify-content-center countdown">
        <Countdown date={form.dateEnd} renderer={rendererCountdown}
          onComplete={()=>{
              props.closeForm();
          }}
        />
        </div> : null }
      </div>
      <div className="row mt-3" >
        <div className="col-md-6">
          <TextField
            color="primary"
            className="w-100"
            onChange={(event: any) => {
              changeFullname(event)
            }}
            required={true}
            label="Nome" />
        </div>
        <div className="col-md-6">
          <TextField
            color="primary"
            className="w-100"
            onChange={(event: any) => {
              changeSurname(event)
            }}
            required={false}
            label="Cognome" />
        </div>
      </div>
      <div className="row">

        {
          form.params.map((item, idx) => {

            if (item.type === TYPEDATA.INPUT)
              return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id} >
                <TextField
                  color="primary"
                  className="w-100"
                  onChange={(event: any) => {
                    changeValue(idx, event)
                  }}
                  helperText={item.infolabel ? item.infolabel : null }
                  required={item.required ? true : false}
                  itemID={item.id} label={item.label} />
              </div>)

            if (item.type === TYPEDATA.INPUTNUMBER)
              return(

               <div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}>
                <TextField
                  color="primary"
                  className="w-100"
                  type="number"
                  helperText={item.infolabel ? item.infolabel : null }
                  onChange={(event: any) => {
                    changeValue(idx, event)
                  }}
                  required={item.required ? true : false}
                  itemID={item.id} label={item.label} />
              </div>)

            if (item.type === TYPEDATA.CHECKBOX){
              if(form.params[idx].value === '' ){
                form.params[idx].value = "no";
                setForm(form);
              }
           
              return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onChange={(event) => {
                        changeValueCkeckbox(idx, event)
                      }}
                      aria-required={true}
                      required={item.required ? true : false}
                    />
                  }
                  
                  label={item.label+(item.required ? "*" : "")}
                />
                 <FormHelperText>{item.infolabel ? item.infolabel : null }</FormHelperText>
              </div>)
            }

                  if (item.type === TYPEDATA.LIST)
                    return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}>
                      <FormControl color="primary" className="w-100"
                        required={item.required}
                        

                      >
                        <InputLabel id={item.id}>{item.label}</InputLabel>
                        <Select
                          labelId={item.id}
                          id={item.id}
                          
                          onChange={(event: any) => {
                            changeValue(idx, event)
                          }}
                        >
                          {
                            item.options.map(value => {
                              return <MenuItem value={value} key={value} >{value}</MenuItem>
                            })
                          }


                        </Select>
                        <FormHelperText>{item.infolabel ? item.infolabel : null }</FormHelperText>
                      </FormControl>
                  </div>)
                     if (item.type === TYPEDATA.EMAIL)
                     return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id} >
                       <TextField
                         error={errorEmail}
                         name="email"
                         color="primary"
                         className="w-100"
                         type="email"
                         helperText={item.infolabel ? item.infolabel : null }
                         onChange={(event: any) => {
                           changeValue(idx, event)
                         }}
                         required={item.required ? true : false}
                         itemID={item.id} label={item.label} />
                     </div>)


                    if (item.type === TYPEDATA.DATE)
                    return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}  >
                         <TextField
                            className="w-100"
                              id={item.id}
                              label={item.label}
                              required={item.required}
                              type="date"
                              helperText={item.infolabel ? item.infolabel : null }
                              onChange={(event: any) => {
                                changeValue(idx, event)
                              }}
                               
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                    </div>)

                    if (item.type === TYPEDATA.DATETIME)
                    return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}  >
                        <TextField
                            className="w-100"
                              id={item.id}
                              label={item.label}
                              required={item.required}
                              type="datetime-local"
                              helperText={item.infolabel ? item.infolabel : null }
                              onChange={(event: any) => {
                                changeValue(idx, event)
                              }}
                              
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />                        
                        </div>)

                    if (item.type === TYPEDATA.TIME)
                    return (<div className="col-12 col-md-6 col-sm-12 p-3" key={item.id}  >
                        <TextField
                            className="w-100"
                              id={item.id}
                              label={item.label}
                              required={item.required}
                              type="time"
                              helperText={item.infolabel ? item.infolabel : null }
                              onChange={(event: any) => {
                                changeValue(idx, event)
                              }}
                              
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />                        
                        </div>)

                    
                  return null
          })
        }


      </div>

      <>
        {form.privacy ?
          <div className="row mt-3">
            <div className="col-md-12 d-flex justify-content-center align-items-center">
              <Checkbox
                color="primary"
                onChange={(event) => {

                  changeReadPrivacy(event.target.checked)
                }}

              />
            
                <p className="p-0 m-0 privacy" >
                Accetto i <span   onClick={()=>{
                  window.open(form.privacy,"_blank")
              }}>Termini di Privacy</span> e autorizzo Comunicazioni su { Utils.isTelegram() ? <>Telegram</> : <>WhatsApp</>  } e il Trattamento dei miei Dati Personali ai sensi del REGOLAMENTO EUROPEO SULLA PRIVACY 679/2016 E LA NORMATIVA ITALIANA IN VIGORE. *
                </p>
             
              
            </div>
          </div> : null
        }
      </>
      <div className="row  mt-3">
        <div className="col-md-12">
             <p className="requierd">* Campi obbligatori</p>
        </div>
      
      </div>
      <div className="row  mt-3">
        <div className="col-md-12 d-flex justify-content-center" >
          <Button variant="contained" color="primary" disabled={!formValidate} onClick={handleConfirmSend}>
           {form.textSubmit ? form.textSubmit : "Invia Dati" } 
          </Button>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={text ? true : false}
        autoHideDuration={6000}
     
        message="Il codice è stato compiato"

      />
      <InfoSend open={statusSend} handleClose={()=>{ setStatusSend(false);}}   handleSuccess={handleSendData}  title="Conferma Invio Dati"/>
    </div>
 
}
